
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { LicenseManager } from 'ag-grid-enterprise';

// import { agGridLicense } from './app/shared/constants/ag-grid-license.constant';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

// LicenseManager.setLicenseKey(agGridLicense);

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
